import { render, staticRenderFns } from "./AuxilioBrasil.vue?vue&type=template&id=8693d0c6&"
import script from "./AuxilioBrasil.vue?vue&type=script&lang=js&"
export * from "./AuxilioBrasil.vue?vue&type=script&lang=js&"
import style0 from "./AuxilioBrasil.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports